// Farben für Räume
export const ROOM_COLORS = [
  '#bfdbfe', // blue-200
  '#bbf7d0', // green-200
  '#fde68a', // yellow-200
  '#fecaca', // red-200
  '#e9d5ff', // purple-200
  '#cffafe', // cyan-200
  '#fed7aa', // orange-200
  '#f5d0fe', // fuchsia-200
];

// Wand-Farben
export const WALL_COLORS = {
  exterior: '#f59e0b', // amber-500
  interior: '#3b82f6', // blue-500
  selected: '#ef4444', // red-500
  hover: '#8b5cf6',    // violet-500
};

// Punkt-Typen
export const POINT_TYPES = {
  WALL: 'wall',           // Wandpunkte (Innenkante) - trennen Wände
  WALL_OUTER: 'wallOuter', // Wand-Außenpunkte - automatisch aus Innenpunkten berechnet
  AUXILIARY: 'auxiliary', // Hilfspunkte - für Schächte/Vorwände, trennen keine Wände
};

// Punkt-Farben
export const POINT_COLORS = {
  normal: '#ffffff',
  selected: '#3b82f6',
  hover: '#60a5fa',
  pending: '#22c55e', // green-500
  // Farben für Hilfspunkte (Schächte/Vorwände)
  auxiliary: '#a78bfa',        // violet-400
  auxiliarySelected: '#7c3aed', // violet-600
  auxiliaryHover: '#c4b5fd',   // violet-300
  // Farben für Außenpunkte (Wandaußenseite)
  outer: '#f97316',            // orange-500
  outerSelected: '#ea580c',    // orange-600
  outerHover: '#fb923c',       // orange-400
};

// Größen (alle in mm, da Koordinatensystem in mm)
export const SIZES = {
  pointRadius: 150,        // 15cm Radius für sichtbare Punkte
  pointRadiusSelected: 200, // 20cm wenn ausgewählt
  wallWidth: 50,           // 5cm Linienbreite
  wallWidthSelected: 80,   // 8cm wenn ausgewählt
  gridStep: 1000,          // 1m Raster
  snapThreshold: 200,      // 20cm Snap-Radius
};

// Tool-Typen
export const TOOLS = {
  // Selection & Navigation
  SELECT: 'select',
  PAN: 'pan',
  ZOOM: 'zoom',

  // Pure Geometry Tools (Rhino-like)
  POINT: 'point',           // Click to place points anywhere
  LINE: 'line',             // Click-click for straight line
  POLYLINE: 'polyline',     // Multi-click, Enter to finish
  ARC: 'arc',               // 3-point arc
  ARC_CENTER: 'arcCenter',  // Center-start-end arc
  CIRCLE: 'circle',         // Center + radius
  RECTANGLE: 'rectangle',   // 2-corner rectangle
  POLYGON: 'polygon',       // Regular polygon
  CONSTRUCTION_LINE: 'constructionLine', // Infinite construction/guide line

  // Solid Tools
  BOX: 'box',
  CYLINDER: 'cylinder',
  SPHERE: 'sphere',
  EXTRUDE: 'extrude',       // Extrude curve
  REVOLVE: 'revolve',       // Revolve curve around axis

  // Transform Tools
  MOVE: 'move',
  COPY: 'copy',
  ROTATE: 'rotate',
  SCALE: 'scale',
  MIRROR: 'mirror',
  ARRAY: 'array',

  // Building Tools (Legacy + Enhanced)
  WALL: 'wall',             // Building wall from curve
  SPACE: 'space',           // Building space/room
  SHAFT: 'shaft',           // Technical shaft
  STUB_WALL: 'stubWall',    // Stub wall / Vorwand

  // Measurement
  MEASURE: 'measure',
};

// Tool categories for UI grouping
export const TOOL_CATEGORIES = {
  SELECTION: ['select'],
  GEOMETRY_CURVES: ['point', 'line', 'polyline', 'arc', 'arcCenter', 'circle', 'rectangle', 'polygon', 'constructionLine'],
  GEOMETRY_SOLIDS: ['box', 'cylinder', 'sphere', 'extrude', 'revolve'],
  TRANSFORM: ['move', 'copy', 'rotate', 'scale', 'mirror', 'array'],
  BUILDING: ['wall', 'space', 'shaft', 'stubWall'],
  MEASURE: ['measure'],
};

// Default layers (Rhino-style)
export const DEFAULT_LAYERS = [
  { id: 'default', name: 'Default', color: '#ffffff', visible: true, locked: false },
  { id: 'construction', name: 'Hilfslinien', color: '#808080', visible: true, locked: false },
  { id: 'walls', name: 'Wände', color: '#3b82f6', visible: true, locked: false },
  { id: 'spaces', name: 'Räume', color: '#22c55e', visible: true, locked: false },
  { id: 'solids', name: 'Körper', color: '#8b5cf6', visible: true, locked: false },
];

// Schacht-Farben (technische Elemente)
export const SHAFT_COLORS = [
  '#6b7280', // Gray
  '#78716c', // Stone
  '#71717a', // Zinc
  '#737373', // Neutral
];

// Standard-Geschosshöhe
export const DEFAULT_STOREY_HEIGHT = 2750; // mm

// Solid-Farben (3D-Körper)
export const SOLID_COLORS = {
  box: '#6b7280',      // gray-500
  cylinder: '#0ea5e9', // sky-500
  extrusion: '#8b5cf6', // violet-500
  selected: '#3b82f6', // blue-500
  hover: '#60a5fa',    // blue-400
};

// Geometry Colors (Pure CAD objects)
export const GEOMETRY_COLORS = {
  // Points
  point: '#ffffff',
  pointSelected: '#3b82f6',
  pointHover: '#60a5fa',

  // Curves
  line: '#00ff00',         // Green for lines
  lineSelected: '#22c55e',
  polyline: '#00ff00',
  polylineSelected: '#22c55e',
  arc: '#ff9900',          // Orange for arcs
  arcSelected: '#f59e0b',
  circle: '#ff9900',
  circleSelected: '#f59e0b',

  // Surfaces
  surface: '#a78bfa',      // Violet for surfaces
  surfaceSelected: '#7c3aed',

  // Generic
  construction: '#808080', // Gray for construction geometry
  selected: '#3b82f6',
  hover: '#60a5fa',
  pending: '#22c55e',      // Green for pending/preview
};
